// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"ced958b5","607":"0d9e43fb","827":"8a62e6fe"}[chunkId] + ".css";
};